import { Pipe, PipeTransform, LOCALE_ID, Inject } from '@angular/core';
import { DecimalPipe } from '@angular/common';

import { WeightsUom, Convert } from '@library/common/models';

@Pipe({ name: 'dualweights' })
export class DualWeightsPipe implements PipeTransform {
   constructor( @Inject(LOCALE_ID) private locale: string) { }

   transform( value: number, valueIs: WeightsUom = WeightsUom[0], order: string[] = [ 'lbs', 'kgs' ]): string {
      if ( !valueIs ) { valueIs = WeightsUom[0]; }
      const decimal = new DecimalPipe( this.locale );

      const values = {
         lbs: decimal.transform( Convert( value, valueIs, 'lbs' ), '1.0-2', this.locale ) + ' lbs',
         kgs: decimal.transform( Convert( value, valueIs, 'kgs' ), '1.0-2', this.locale ) + ' kgs',
      };

      return order.map( o => values[o] ).filter( _ => !!_ ).join( ' / ' );
   }
}

@Pipe({ name: 'totalweight', pure: false })
export class TotalWeightPipe implements PipeTransform {
   transform( value: { weight: number, weight_type: WeightsUom, pieces: number }[], output: WeightsUom = 'lbs' ): number {
      return value.map( item => Convert( item.weight, item.weight_type, output ))
         .reduce(( a, c ) => a + c, 0 );
   }
}

@Pipe({ name: 'totaldualweight' })
export class TotalDualWeightPipe implements PipeTransform {
   constructor( @Inject(LOCALE_ID) private locale: string) { }

   transform( value: { weight: number, weight_type: WeightsUom, pieces: number }[] ): string {
      const dual = new DualWeightsPipe( this.locale );
      const total = new TotalWeightPipe();

      const weight_types = value.filter( item => item.weight ).map( item => item.weight_type );
      const counts = {
         lbs: weight_types.filter( t => t === 'lbs' ).length,
         kgs: weight_types.filter( t => t === 'kgs' ).length,
      };

      if ( counts.lbs >= counts.kgs ) {
         return dual.transform( total.transform( value, 'lbs' ), 'lbs', [ 'lbs', 'kgs' ] );
      } else {
         return dual.transform( total.transform( value, 'kgs' ), 'kgs', [ 'kgs', 'lbs' ] );
      }
   }
}
